import {
  FaFacebookF,
  FaInstagram,
  FaXTwitter,
  FaYoutube,
} from "react-icons/fa6";

const Footer = () => {
  return (
    <footer className="bg-white text-black px-6 py-10 mt-16 border-t">
      <div className="max-w-screen-xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
        {/* Left: Links */}
        <div>
          <h4 className="font-bold mb-4">MORE LINKS</h4>
          <div className="grid grid-cols-2 gap-y-2 text-sm">
            <a href="#">SIGN IN</a>
            <a href="#">NOW SHOWING</a>
            <a href="#">FAQS</a>
            <a href="#">REGISTER</a>
            <a href="#">COMING SOON</a>
            <a href="#">CORPORATE</a>
            <a href="#">LOCATIONS</a>
            <a href="#">CONTACT US</a>
            <a href="#">PROMOTIONS</a>
            <a href="#">TERMS AND CONDITIONS</a>
            <a href="#">PRIVACY POLICY</a>
            <a href="#">AGE RATING</a>
          </div>
        </div>

        {/* Center: App Buttons */}
        <div className="text-center">
          <h4 className="font-bold mb-4">DOWNLOAD OUR MOBILE APP</h4>
          <div className="flex justify-center items-center gap-4">
            <img
              src="/d1.png"
              alt="Google Play"
              className="h-12 object-contain"
            />
            <img
              src="/d2.png"
              alt="App Store"
              className="h-12 object-contain"
            />
          </div>
        </div>

        {/* Right: Social */}
        <div className="text-center md:text-right">
          <h4 className="font-bold mb-4">SOCIAL MEDIA</h4>
          <div className="flex justify-center md:justify-end gap-4 text-2xl">
            <a href="#"><FaFacebookF /></a>
            <a href="#"><FaInstagram /></a>
            <a href="#"><FaXTwitter /></a>
            <a href="#"><FaYoutube /></a>
          </div>
        </div>
      </div>

      {/* Bottom */}
      <div className="text-center text-sm mt-10">
        Copyright 2025 Cinescape. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
